import z from 'zod';
export const procedureIdValue = z.string().trim().min(1)
    .brand('ProcedureId');
export const createProcedureId = (value) => procedureIdValue.parse(value);
export const isProcedureId = (value) => procedureIdValue.safeParse(value).success;
/** Legal case (dossier) opened from a catalog procedure. */
export const caseIdValue = z.string().trim().min(1)
    .brand('CaseId');
export const createCaseId = (value) => caseIdValue.parse(value);
export const isCaseId = (value) => caseIdValue.safeParse(value).success;
/** Strapi client (entreprise cliente du cabinet). */
export const clientIdValue = z.string().trim().min(1)
    .brand('ClientId');
export const createClientId = (value) => clientIdValue.parse(value);
export const isClientId = (value) => clientIdValue.safeParse(value).success;
/** Strapi employee (salarié rattaché à un client). */
export const employeeIdValue = z.string().trim().min(1)
    .brand('EmployeeId');
export const createEmployeeId = (value) => employeeIdValue.parse(value);
export const isEmployeeId = (value) => employeeIdValue.safeParse(value).success;
//# sourceMappingURL=ids.js.map